<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar title="部分适配机型">
      </black-bar>
    </div>
    <p class="title">武汉通SIM交通卡目前只适用于支持NFC功能的安卓手机，苹果手机不支持使用。部分支持的手机机型有：</p>
    <img src="../assets/img/noAccess/img_list@2x.png"
         alt="">

  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
export default {
  name: 'PhoneType',
  data () {
    return {
      loading: true,
      num: 20
    }
  },
  components: {
    blackBar
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}

img {
  width: 80%;
  margin-top: 40px;
}

.title {
    font-size: 24px;
    color: #333;
    margin: 20px 20px 0 20px;
    text-align: left;
  }

</style>
